import { ILocalTrack, IRoom, LocalTrackState, Scene, UserRole } from '..';
import innerEmitter from '../inner-emitter/inner-emitter';
import { INNER_EVENT } from '../inner-emitter/inner-type';
import { createDecorator } from '../plugin';

export function beforePublish() {
  return createDecorator<IRoom>(publish => async function (this: IRoom, ...localTracks: ILocalTrack[]) {
    if (this.scene === Scene.LIVE && this.role !== UserRole.ANCHOR) return;
    localTracks = localTracks.filter(t => t.outMediaTrack && t.state === LocalTrackState.READY); // 过滤掉空的track
    if (!localTracks.length) return;
    innerEmitter.emit(INNER_EVENT.PUBLISH_START, { room: this });
    const promise = publish.apply(this, localTracks);
    return Promise.all(localTracks.map(localTrack => localTrack.publish(this, promise)));
  });
}

export function beforeUnpublish() {
  return createDecorator<IRoom>(unpublish => function (this: IRoom, ...localTracks: ILocalTrack[]) {
    const promise = unpublish.apply(this, localTracks);
    localTracks.forEach(localTrack => localTrack.unpublish());
    return promise;
  });
}
